import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovStateProps,
    LoadMarkovStateById,
    setMarkovStateEdit,
    setMarkovStateReloadEdit,
    initMarkovState,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    stateId = null,
}: MarkovStateProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const mState = useSelector((state: StoreType) => state.markovState.stateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovState.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovStateReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovStateReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (stateId === 0) {
            dispatch(setMarkovStateEdit(initMarkovState))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovStateById(stateId, model.id).then((res) => {
                dispatch(setMarkovStateEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!mState) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{mState.id ? `${lang.editState} # ${mState.id}` : lang.addState}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form mState={mState} />
                }
                {
                    reloadEdit
                    && <Form mState={mState} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
